/* import __COLOCATED_TEMPLATE__ from './escalation-section.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type Guideline from 'embercom/models/ai-agent/guidelines';
import type EscalationRule from 'embercom/models/ai-agent/escalation-rule';
import { type PulseAccordionSection } from 'glint/pulse';
import type AiAgentGuidelineService from 'embercom/services/ai-agent-guideline-service';
import { inject as service } from '@ember/service';

interface Signature {
  Element: HTMLDivElement;
  Blocks: {
    escalationHeader: [
      {
        header: PulseAccordionSection['Header'];
        guideline?: Guideline;
      },
    ];
    escalationBody: [
      {
        guideline?: Guideline;
      },
    ];
  };
  Args: {
    accordionSection: PulseAccordionSection;
    selectedEscalationType: EscalationType;
    guideline?: Guideline;
    escalationRule?: EscalationRule;
  };
}

type EscalationType = 'rule-based' | 'text-based';

export default class EscalationSection extends Component<Signature> {
  @service declare aiAgentGuidelineService: AiAgentGuidelineService;

  @tracked selectedEscalationType = this.args.selectedEscalationType;
  @tracked guideline = this.args.guideline;
  @tracked escalationRule = this.args.escalationRule;
  @tracked showConfirmationModal = false;

  get notSelectedEscalationType() {
    return this.selectedEscalationType === 'rule-based' ? 'text-based' : 'rule-based';
  }

  @action
  onSelectionChange() {
    this.showConfirmationModal = true;
  }

  @action
  async toggleEscalationType() {
    this.selectedEscalationType = this.notSelectedEscalationType;
    this.showConfirmationModal = false;

    if (this.selectedEscalationType === 'rule-based') {
      if (this.guideline) {
        this.guideline = undefined;
        // we can't destroy the guideline record for now - otherwise it disappears from the list
        // so keeping the actual it for now but wiping the property
        // we need to either destroy the record on save, or change the modal to only appear on save
      }
      // TODO: create new escalation rule
    } else if (this.selectedEscalationType === 'text-based') {
      this.escalationRule = undefined;
      this.guideline =
        this.args.guideline ||
        (await this.aiAgentGuidelineService.createNewGuideline('routing', null));
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Guidance::EscalationSection': typeof EscalationSection;
    'ai-agent/guidance/escalation-section': typeof EscalationSection;
  }
}
